<template>
    <footer class="bg-black">

    </footer>
</template>

<script>
    export default {
        name: 'UserPanelFooter'
    }
</script>

<style lang="scss" scoped>
    @import "@/assets/style/utils/_variables.scss";
    footer {
        height: 50px;
        padding: 15px;
    }
    .bg-black {
        background-color: $user-bg-black;
    }
</style>



// WEBPACK FOOTER //
// src/components/UserPanel/Elements/UserPanelFooter.vue